<ng-container>
  <mat-toolbar class="layout-header" color="primary">
    <div class="header-left">
      <button
        mat-icon-button
        class="menu-toggle"
        aria-label="Toggle navigation menu"
        (click)="toogleNavMenu(sidenav)">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="header-title">Admin Portal</span>
    </div>
    <div class="layout-spacer"></div>
    <div class="header-right">
      <div class="badges-container">
        <button
          mat-icon-button
          class="header-icon-btn"
          matTooltip="Messages"
          (click)="openMessages()">
          <mat-icon
            [matBadge]="unreadMessages"
            matBadgeColor="accent"
            [matBadgeHidden]="unreadMessages === 0"
            matBadgeSize="small"
            >chat</mat-icon
          >
        </button>

        <button
          mat-icon-button
          class="header-icon-btn"
          matTooltip="Notifications"
          [matMenuTriggerFor]="notificationMenu">
          <mat-icon
            [matBadge]="unreadNotifications"
            matBadgeColor="warn"
            [matBadgeHidden]="unreadNotifications === 0"
            matBadgeSize="small"
            >notifications</mat-icon
          >
        </button>
        <mat-menu
          #notificationMenu="matMenu"
          class="notification-menu"
          xPosition="before">
          <ng-template matMenuContent>
            <app-layout-notifications-panel
              [notifications]="notifications"
              (notificationClick)="handleNotificationClick($event)"
              (clearAll)="clearAllNotifications()">
            </app-layout-notifications-panel>
          </ng-template>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="layout-container" autosize>
    <mat-sidenav
      #sidenav
      mode="side"
      opened
      class="layout-sidenav"
      [fixedInViewport]="false"
      [fixedTopGap]="0"
      [fixedBottomGap]="0">
      <nav class="nav-list">
        <!-- Main Navigation -->
        <div class="nav-section">
          <span class="nav-section__title">Main Menu</span>
          <ul class="nav-menu">
            <li *ngFor="let link of links" class="nav-menu__item">
              <a
                [routerLink]="link.link"
                routerLinkActive="nav-link--active"
                class="nav-link">
                <mat-icon class="nav-link__icon">{{ link.icon }}</mat-icon>
                <span class="nav-link__label">{{ link.label }}</span>
              </a>
              <!-- Child items -->
              <ul *ngIf="link.children?.length" class="nav-submenu">
                <li
                  *ngFor="let child of link.children"
                  class="nav-submenu__item">
                  <a
                    [routerLink]="child.link"
                    routerLinkActive="nav-link--active"
                    class="nav-link nav-link--child">
                    <mat-icon class="nav-link__icon">{{ child.icon }}</mat-icon>
                    <span class="nav-link__label">{{ child.label }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="nav-spacer"></div>

        <!-- Bottom Section -->
        <div class="nav-bottom">
          <!-- Impersonate -->
          <div class="nav-impersonate" *ngIf="userSelectValues.length > 0">
            <form [formGroup]="impersonateFormGroup" novalidate>
              <mat-form-field appearance="outline" class="impersonate-field">
                <mat-label>
                  <mat-icon>swap_horiz</mat-icon>
                  Impersonate User
                </mat-label>
                <mat-select
                  formControlName="user"
                  (valueChange)="handleUserSelected($event)">
                  <mat-option
                    *ngFor="let user of userSelectValues"
                    [value]="user.value">
                    {{ user.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </div>

          <!-- User Info -->
          <div class="nav-user">
            <div class="nav-user__avatar">
              <mat-icon>account_circle</mat-icon>
            </div>
            <div class="nav-user__info">
              <span class="nav-user__name">{{ username }}</span>
              <span class="nav-user__role">Administrator</span>
            </div>
          </div>

          <!-- Logout -->
          <button class="nav-logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </div>
      </nav>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="layout-router-outlet">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- <mat-toolbar class="layout-footer">
    <div><p>Footer</p></div>
  </mat-toolbar> -->
</ng-container>
